import Phaser from "phaser";
import Scene1 from "../scenes/Scene2";

export default class Kunai extends Phaser.Physics.Arcade.Sprite
{
    constructor(scene,x,y,texture){
        super(scene,x,y,texture)
        this.setScale(0.7)
        this.speed = 500 


    }
    
    shot(x,y)
    {
        this.setPosition(x + 30 ,y)
        this.setActive(true)
        this.setVisible(true)
    }
    erase()
    {
        this.destroy()
    }

    update(time)
    {
        this.setVelocityX(this.speed)
            if(this.x > 1920){
                this.erase()
            }
        }
    
}